import {
    USER_INFO_SUCCESS,
    USER_INFO_FAILURE,
    GET_INITIAL_DATA_REQUEST,
    GET_INITIAL_DATA_REQUEST_SUCCESS,
} from '../constants/user_info.constants';

export const getUserInfoSuccess = payload => ({ type: USER_INFO_SUCCESS, payload });
export const getUserInfoFailure = error => ({ type: USER_INFO_FAILURE, error });
export const getInitialDataRequest = token => ({ type: GET_INITIAL_DATA_REQUEST, token });
export const getInitialDataRequestSuccess = () => ({ type: GET_INITIAL_DATA_REQUEST_SUCCESS });



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/user_info.actions.js